import axios from '.';

export default {
    downloadWithdrawalInvoice,
};

async function downloadWithdrawalInvoice(data) {
  const response = await axios.post('api/invoices/withdrawal_confirm_invoice',data,{
    responseType: 'arraybuffer',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
    }
});
  const url = window.URL.createObjectURL(new Blob([response.data]));
  console.log(url)
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download',  `${data.payment_id}_${data?.paid_date}.pdf`); //or any other extension
  document.body.appendChild(link);
  link.click();
  return response.data;
}
